// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let ConversationMessageArea = require("../../../reason/conversations/components/ConversationMessageArea.bs.js");
let ConversationInput__Attachments = require("../../../reason/conversations/components/ConversationInput__Attachments.bs.js");

function ConversationsSection__ConversationMessageArea(props) {
  let __focusOnMount = props.focusOnMount;
  let attachmentsManager = props.attachmentsManager;
  let form = props.form;
  let focusOnMount = __focusOnMount !== undefined ? __focusOnMount : false;
  let match = React.useState(() => false);
  let setInputIsFocused = match[1];
  let fallbackRef = React.useRef(null);
  let inputRef = Stdlib_Option.getOr(props.inputRef, fallbackRef);
  React.useEffect(() => {
    let match = inputRef.current;
    if (focusOnMount && !(match == null)) {
      match.focus({
        preventScroll: true
      });
    }
  }, []);
  let attachments = attachmentsManager.attachments;
  return JsxRuntime.jsx(ConversationMessageArea.make, {
    isFocused: match[0],
    inputRef: inputRef,
    text: form.input.text,
    onChangeText: text => form.updateText((input, text) => ({
      text: text,
      attachments: input.attachments
    }), text),
    textInputDisabled: form.submitting,
    onFocus: param => setInputIsFocused(param => true),
    onBlur: param => setInputIsFocused(param => false),
    onKeyDown: e => {
      if (e.key === "Enter" && e.metaKey && form.valid()) {
        return form.submit();
      }
    },
    attachments: attachments.length !== 0 ? JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationInput__Attachments.make, {
          uploads: attachments,
          onDeleteAttachment: attachmentsManager.delete
        }),
        className: "pt-1"
      }) : null,
    buttons: JsxRuntime.jsxs(ViewStack.make, {
      justifyContent: "spaceBetween",
      flexDirection: "row",
      children: [
        JsxRuntime.jsx(ConversationInput__Attachments.AddButton.make, {
          onAddAttachment: attachmentsManager.add
        }),
        JsxRuntime.jsx(ViewStack.make, {
          alignItems: "center",
          justifyContent: "flexEnd",
          flexDirection: "row",
          children: props.submitButtons
        })
      ]
    }),
    placeholder: props.placeholder
  });
}

let ConversationMessageForm;

let make = ConversationsSection__ConversationMessageArea;

exports.ConversationMessageForm = ConversationMessageForm;
exports.make = make;
/* react Not a pure module */
